'use strict';

require('./dropdown.base.field.css');

export default class DropdownBaseFieldComponent {
  constructor() {
    this.restrict = 'E';
    this.template = require('./dropdown.base.field.html');
    this.scope = {
      field: '=',
      isDerivedFromTemplate: '='
    };
    this.controller = DropdownBaseFieldController;
    this.controllerAs = 'ctrl';
    this.bindToController = true;
  }
}


/* @ngInject */
class DropdownBaseFieldController {
  constructor() {}
}
